import SubmitButton from './SubmitButton'
import expectSubmitDisabled from './testHelper/expectSubmitDisabled'
import expectSubmitEnabled from './testHelper/expectSubmitEnabled'
import expectSubmitExists from './testHelper/expectSubmitExists'
import submitForm from './testHelper/submitForm'

export default SubmitButton

export { expectSubmitDisabled, expectSubmitEnabled, expectSubmitExists, submitForm }
